/* eslint-disable global-require */
/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import Head from 'next/head';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import NavBarVertical from '../../Components/NavBarVertical';
import NavBarMobile from '../../Components/NavBarMobile';

class Administer extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">Edvice</title>
          <meta key="og:title" property="og:title" content="Edvice" />
          <meta key="description" name="description" content="Edvice" />
          <meta key="og:description" property="og:description" content="Edvice" />
        </Head>

        <Navbar>Navbar</Navbar>
        {/* image={require('./laptop-image.png')} */}
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./linguaskill_desktop.png')}
            column="col-xs-5"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Information about the Linguaskill test</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobile />
              <NavBarVertical />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="administer-format-content">
                <div className="section__one">
                  <h1>How to administer the test</h1>
                  <h2>How the Linguaskill test is delivered</h2>
                  <p>
                    Linguaskill is simple to use for both agents and candidates, and is administered
                    through the Cambridge English Test Portal. This video shows the five key
                    features of the portal and how to use them.
                  </p>
                </div>
                <br />
                <iframe
                  width="100%"
                  height="402"
                  src="https://www.youtube.com/embed/9xuAzUpl4FU"
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                <div className="section__two">
                  <h2>The technical requirements for running a Linguaskill test</h2>
                  <p>
                    <strong>Minimum technical requirements</strong>
                  </p>
                  <table className="table__style">
                    <tbody>
                      <tr>
                        <td>Processor</td>
                        <td>Pentium III 800 MHz or equivalent</td>
                      </tr>
                      <tr>
                        <td>RAM</td>
                        <td>512 MB</td>
                      </tr>
                      <tr>
                        <td>Free Hard Drive Space</td>
                        <td>512 MB</td>
                      </tr>
                      <tr>
                        <td>Screen Resolution</td>
                        <td>1280 x 1024</td>
                      </tr>
                      <tr>
                        <td>
                          Operating System
                          <br />
                          Note:
                        </td>
                        <td>
                          <p>Windows 7 or later </p>
                          <p>
                            The Cambridge English Test portal and any tests run through it are not
                            currently supported on
                            <strong>iOS</strong>
                            or
                            <strong>Android</strong>
                            devices.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>Internet Bandwidth</td>
                        <td>
                          <p>2 Mbps per candidate.</p>
                          <p>
                            The minimum bandwidth requirements are for each computer running the
                            test. When running multiple tests concurrently on the same internet
                            connection you should ensure this bandwidth is available to each
                            computer. If less than 2 Mbps is available for each candidate, the test
                            may take longer to run.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>Web Browser</td>
                        <td>Chrome, Internet Explorer or Firefox</td>
                      </tr>
                      <tr>
                        <td>Adobe Reader</td>
                        <td>Latest version (must be able to read PDF’s</td>
                      </tr>
                      <tr>
                        <td>Adobe Flash Player</td>
                        <td>Version 26 or later</td>
                      </tr>
                      <tr>
                        <td>Sound Card</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td>Headphones</td>
                        <td>
                          Over-ear and closed back – the earpieces of the headphones should cover
                          the entire ear, preferably with good padding for comfort.
                        </td>
                      </tr>
                      <tr>
                        <td>Microphone</td>
                        <td>
                          <p>
                            A microphone should be attached to the headset, via a ‘boom’ (in other
                            words, on the end of a flexible stalk). The microphone should be
                            noise-cancelling (at a minimum, directional), to increase sound pick-up
                            and to minimise noise pollution on the recordings.
                          </p>
                          <p>
                            Please do not allow the use of your computers’ built-in microphones,
                            these should be disabled, because they are not of the appropriate type
                            nor of sufficient quality. In addition in Chrome if a candidate mutes
                            their headset mic, Linguaskill will continue recording if there‘s more
                            than one mic enabled on the machine.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>Headphones and microphone connections</td>
                        <td>
                          There is no preference on plugs (that is, USB or standard stereo) but
                          please note that the use of USB means that appropriate drivers must be
                          installed
                          <strong>and confirmed as working </strong>
                          before the test day.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default Administer;
